import React, { useEffect, useState } from 'react';
import { View, Text } from 'react-native';
import {
  WorkoutContainerHeaderTwo,
  WorkoutContainerHeaderThree,
  WorkoutContainerText,
  WorkoutTextHeader
} from '../../../styles/common-styles.js';
import styled from 'styled-components/native';
import StreakRow from './StreakRow.js';

function splitIntoWeeks(list) {
  let weeks = [];
  for (let i = 0; i < list.length; i += 7) {
    weeks.push(list.slice(i, i + 7));
  }
  return weeks;
}

function StreakCalendar({date_obj}) {
  const [weeks, setWeeks] = useState([]);

  useEffect(() => {
    try {
      setWeeks(splitIntoWeeks(date_obj));
    } catch(e){console.log(e)}
  }, [date_obj]);

  function checkForDuplicateDay(dayToCheck, indexToCheck){
    let firstOccurrenceIndex = -1;

    for (let i = 0; i < date_obj.length; i++) {
      if (date_obj[i].day === dayToCheck) {
        if (firstOccurrenceIndex === -1) {
          firstOccurrenceIndex = i;
        } else if (i === indexToCheck) {
          return true;
        }
      }
    }

    return false;
  }

  return (
    <StreakCalendarParent>
      <WeekDayKey>
        <WeekDayKeyText></WeekDayKeyText>
        <WeekDayKeyText>S</WeekDayKeyText>
        <WeekDayKeyText>M</WeekDayKeyText>
        <WeekDayKeyText>T</WeekDayKeyText>
        <WeekDayKeyText>W</WeekDayKeyText>
        <WeekDayKeyText>T</WeekDayKeyText>
        <WeekDayKeyText>F</WeekDayKeyText>
        <WeekDayKeyText>S</WeekDayKeyText>
        <WeekDayKeyText></WeekDayKeyText>
      </WeekDayKey>

      {weeks.map((week, index) => (      
        <StreakRowContainer>
          <StreakRow key={index} week={week} checkForDuplicateDay={checkForDuplicateDay}></StreakRow>
        </StreakRowContainer>
      ))}
      
    </StreakCalendarParent>
  );
}

export const StreakCalendarParent = styled.View`
  width:100%;
  padding:10px;
  background:transparent;
  overflow: hidden;
`

export const WeekDayKey = styled.View`
  display:flex;
  justify-content:space-evenly;
  align-items:center;
  flex-direction:row;
`

export const WeekDayKeyText = styled(WorkoutContainerText)`
  display:flex;
  justify-content:center;
  align-items:center;
  text-align:center;
  width:25px;
  height:25px;
`

export const StreakRowContainer = styled.View`
  border-radius:50px;
`

export default StreakCalendar;
